import { EventType } from 'src/utils/BigCalendarColourGeneratorUtils';
import {
  KEY_PICKUP_EVENT_TYPE,
  SERVICE_REQUEST_EVENT_TYPE,
  WALKTHROUGH_EVENT_TYPE,
} from 'src/pages/Calendar/types';

export const resolveEventTypeLabel = (juniperEventType: number): string => {
  if (juniperEventType === WALKTHROUGH_EVENT_TYPE) {
    return 'Walkthrough';
  }

  if (juniperEventType === SERVICE_REQUEST_EVENT_TYPE) {
    return 'Service Request';
  }

  if (juniperEventType === KEY_PICKUP_EVENT_TYPE) {
    return 'Key Pickup';
  }

  return 'Event';
};

export const resolveEventTypeStyleKey = (juniperEventType: number): EventType => {
  if (juniperEventType === WALKTHROUGH_EVENT_TYPE) {
    return 'walkthrough';
  }

  if (juniperEventType === KEY_PICKUP_EVENT_TYPE) {
    return 'key-pickup';
  }

  return 'service';
};